module.exports = __webpack_public_path__ + "static/media/ic_filter_active.57175c4f.svg";